import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import type { TransitionProps } from '@mui/material/transitions'
import * as React from 'react'

const Transition = React.forwardRef(function Transition(
	props: TransitionProps & {
		children: React.ReactElement<any, any>
	},
	ref: React.Ref<unknown>
) {
	return <Slide direction='up' ref={ref} {...props} />
})

type AlertDialogProps = {
	title: string
	content: string
	buttonAgree: string
	buttonDisagree: string
	handleDisagree: () => void
	handleAgree: () => void
	open: boolean
	setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export default function AlertDialog({
	title,
	content,
	buttonAgree,
	buttonDisagree,
	handleDisagree,
	handleAgree,
	open,
	setOpen,
}: AlertDialogProps) {
	const handleClose = () => {
		setOpen(false)
	}

	return (
		<div>
			<Dialog
				open={open}
				TransitionComponent={Transition}
				keepMounted
				onClose={handleClose}
			>
				<DialogTitle>{title}</DialogTitle>
				<DialogContent>
					<DialogContentText>{content}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleDisagree}>{buttonDisagree}</Button>
					<Button onClick={handleAgree}>{buttonAgree}</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}
